/* Copyright Verge Technologies 2018
 * @file product.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for housing a product
 */

// Modules
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Query } from 'react-apollo';
import PubSub from 'pubsub-js';
import { PulseLoader } from 'react-spinners';
// GraphQL
import { PRODUCT_QUERY } from '../../graphql';

// Components
import Panel from '../../components/Panel/panel';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeToggle: 'DESCRIPTION',
    };
  }

  // Handler for toggling between panels
  handleToggle = (toggle) => {
    this.setState({
      ...this.state,
      activeToggle: toggle,
    });
  }

  favouriteItem = (event, itemId) => {
    event.preventDefault();
    const favourites = JSON.parse(localStorage.getItem('SEPARATIONS_FAVOURITES'));
    // Check if the item already exists in favourites
    if (favourites.some((favourite) => { return favourite.id === itemId; })) {
      return;
    }
    favourites.push({ id: itemId, quantity: 1 });
    localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify(favourites));
    // Publish the event for the listeners
    PubSub.publish('LOCAL_UPDATE');
  }

  render() {
    return (
      <Query query={PRODUCT_QUERY} variables={{ slug: this.props.slug }} fetchPolicy="cache-and-network" >
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100px' }}>
                <PulseLoader loading={loading} color="#004DA9" sizeUnit="px" size={15} />
              </div>
            );
          }
          if (error) {
            console.log(error);
            return <div>Error</div>;
          }
          return (
            <div className="product-page">
              <div className="tab-container">
                <ul>
                  <li>
                    <a
                      className={this.state.activeToggle === 'DESCRIPTION' ? 'active' : ''}
                      onClick={() => this.handleToggle('DESCRIPTION')}
                    >
                      Description
                    </a>
                  </li>
                  <li>
                    <a
                      className={this.state.activeToggle === 'SPECIFICATION' ? 'active' : ''}
                      onClick={() => this.handleToggle('SPECIFICATION')}
                    >
                      Specifications
                    </a>
                  </li>
                  <li>
                    <a
                      className={this.state.activeToggle === 'DOWNLOADS' ? 'active' : ''}
                      onClick={() => this.handleToggle('DOWNLOADS')}
                    >
                      Downloads
                    </a>
                  </li>
                </ul>
              </div>
              <Panel activeToggle={this.state.activeToggle} favouriteItem={this.favouriteItem} product={data.getItem} />
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(Product);



// WEBPACK FOOTER //
// ./src/components/Product/product.js